import React from 'react';
import { useTabs } from '../../../../hooks/useTabs';
import { InstrumentId } from '../../../../types/common';

interface Props {
  selectInstrument: (value: InstrumentId) => void;
  currentInstrument: InstrumentId;
}

export const Menu: React.FC<Props> = ({ selectInstrument, currentInstrument }) => {
  const { tabs } = useTabs();
  return (
    <>
      {tabs.map(({ Menu, firstAvailable, supports, fee }) => (
        <Menu
          key={firstAvailable}
          fee={fee}
          onClick={() => selectInstrument(firstAvailable)}
          isActive={supports.has(currentInstrument)}
        />
      ))}
    </>
  );
};
